// 🔥 FINAL PERFECT RegisterAttendancePage.js - What's Include Working ✅

import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  MenuItem,
  Box,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./style.scss";
import DialogMessage from "../../DialogMessage";

const RegisterAttendancePage = () => {
  const navigate = useNavigate();
  const { conferenceId, type, priceId } = useParams();

  const { state } = useLocation();
  const {
    conferenceTitle,
    conferenceImage,
    conferenceDate,
    priceType,
    priceAmount,
    priceDescription,
    attendanceId,
    whatsInclude,  // ✅ NEW: Destructure whatsInclude
  } = state || {};

  // ✅ All form fields
  const [title, setTitle] = useState("Mr.");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsApp, setWhatsApp] = useState("");
  const [speciality, setSpeciality] = useState("");

  // ✅ Nationality dropdown
  const [countries, setCountries] = useState([]);
  const [selectedNationalityId, setSelectedNationalityId] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("");

  // ✅ Other fields
  const [country, setCountry] = useState("");
  const [heardFrom, setHeardFrom] = useState("Social media");

  // ✅ Dynamic values
  const [category] = useState(priceDescription || "VIP");
  const [password] = useState("Test@7456");

  // ✅ UI states
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);

  const [formData, setFormData] = useState({
    accept_cancellation_policy: false,
  });

  const API_BASE = "https://eventscons.com/eventbackendnew/api";

  // ✅ FIXED: Parse whats_include string to array (same as SelectConferences)
  const parseWhatsInclude = (whatsIncludeData) => {
    if (!whatsIncludeData) return [];
    
    try {
      // If already array
      if (Array.isArray(whatsIncludeData)) {
        return whatsIncludeData;
      }
      // If JSON string like "[\"Not include\"]"
      else if (typeof whatsIncludeData === 'string') {
        return JSON.parse(whatsIncludeData);
      }
    } catch (e) {
      console.warn("❌ whats_include parse error:", whatsIncludeData);
    }
    return [];
  };

  // ✅ Parse whatsInclude on component load
  const parsedWhatsInclude = parseWhatsInclude(whatsInclude);

  // ✅ Fetch countries
  const fetchCountries = async () => {
    try {
      const res = await axios.get(`${API_BASE}/countries`);
      const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setCountries(list);
    } catch (err) {
      console.error("❌ Countries fetch error:", err);
      toast.error("Countries load nahi ho paayi.");
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  // 🔥 PERFECT FINAL - res.data.attendance.id (47) capture karega
  const handleRegister = async (e) => {
    e.preventDefault();

    if (!name?.trim() || !email?.trim() || !phone || !speciality?.trim() || !selectedNationalityId || !country?.trim()) {
      toast.error("Please fill all required fields.");
      return;
    }

    if (!formData.accept_cancellation_policy) {
      toast.error("Please accept cancellation policy.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: name.trim(),
        email: email.trim(),
        password,
        registration_type: "attendance",
        phone_number: phone.startsWith("+") ? phone.replace("+", "") : phone,
        conference_id: Number(conferenceId) || 62,
        category,
        hear_about_event: heardFrom || "Social media",
        registration_fee: Number(priceAmount) || 150,
        is_visa_payment_required: true,
        // ✅ Dynamic includes from parsed whatsInclude
        includes_conference_bag: parsedWhatsInclude.some(item => 
          item.toLowerCase().includes('bag') || item.toLowerCase().includes('kit')
        ),
        includes_conference_badge: parsedWhatsInclude.some(item => 
          item.toLowerCase().includes('badge')
        ),
        includes_certificate: parsedWhatsInclude.some(item => 
          item.toLowerCase().includes('certificate') || item.toLowerCase().includes('cpd')
        ),
        speciality: speciality.trim(),
        nationality: selectedNationality || null,
        nationality_country_id: selectedNationalityId ? Number(selectedNationalityId) : null,
        country_of_residence: country.trim(),
        whatsapp_number: whatsApp || null,
      };

      console.log("🚀 Registration Payload:", payload);
      console.log("✅ Parsed WhatsInclude:", parsedWhatsInclude);

      // 🔥 STEP 1: Register attendance
      const res = await axios.post(`${API_BASE}/attendance`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("✅ FULL Registration Response:", JSON.stringify(res.data, null, 2));

      setLoading(false);

      // 🔥 PERFECT FIX - attendance.id (47) capture karo
      let attendanceId = null;
      if (res.data?.attendance?.id) {
        attendanceId = res.data.attendance.id;
        console.log("✅ Attendance ID found:", attendanceId);
      } else {
        console.error("❌ attendance.id not found in response:", res.data);
        toast.error("Attendance ID nahi mila. Console check karo.");
        return;
      }

      toast.success(`✅ Attendance created! ID: ${attendanceId}`);
      setIsDialogOpen(true);
      setIsRegistered(true);

      // 🔥 STEP 2: Auto payment - 2 seconds baad
      setTimeout(async () => {
        try {
          const orderPayload = {
            attendance_id: attendanceId
          };

          console.log("🚀 Creating Payment Order:", orderPayload);

          const orderRes = await axios.post(
            `${API_BASE}/attendance/create-order`,
            orderPayload,
            { 
              headers: { "Content-Type": "application/json" } 
            }
          );

          console.log("✅ Payment Order Response:", JSON.stringify(orderRes.data, null, 2));

          const approvalUrl = orderRes?.data?.approval_url || 
                            orderRes?.data?.data?.approval_url || 
                            orderRes?.data?.payment_url ||
                            orderRes?.data?.url;

          if (approvalUrl && approvalUrl.startsWith('http')) {
            console.log("✅ REDIRECTING TO PAYMENT:", approvalUrl);
            toast.success("We are redirecting to payment gateway...");
            window.location.href = approvalUrl;
          } else {
            console.error("❌ No payment URL in response:", orderRes.data);
            toast.error("Payment order ban gaya but payment link nahi mila.");
          }
        } catch (orderError) {
          console.error("❌ PAYMENT ERROR:", orderError.response?.status, orderError.response?.data);
          toast.error("Payment link fail: " + (orderError.response?.data?.message || "Unknown error"));
        }
      }, 2000);

    } catch (error) {
      setLoading(false);
      console.error("❌ REGISTRATION ERROR:", error.response?.data);
      toast.error(error.response?.data?.message || "Registration failed.");
    }
  };

  return (
    <Container
      className="register-attendance-page"
      sx={{
        padding: "20px",
        marginTop: "15vh",
        maxWidth: "900px",
      }}
    >
      {/* ✅ Success Dialog */}
      <DialogMessage
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        message="Registration successful! Payment link generating in 2 seconds..."
        onOk={() => setIsDialogOpen(false)}
        onClose={() => setIsDialogOpen(false)}
      />

      <div className="form-section">
        <Typography
          variant="h4"
          className="form-title"
          gutterBottom
          sx={{ textAlign: "center", fontWeight: 600, color: "#9B1321" }}
        >
          Register for Conference Attendance
        </Typography>

        {/* ✅ FIXED: Conference Details with Dynamic What's Include */}
        {state && (
          <Box
            sx={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "24px",
              display: "flex",
              gap: "16px",
              alignItems: "center",
            }}
          >
            {conferenceImage && (
              <img
                src={
                  conferenceImage.startsWith("http")
                    ? conferenceImage
                    : `https://eventscons.com/eventbackendnew/storage/app/public/${conferenceImage}`
                }
                alt={conferenceTitle}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "6px",
                }}
              />
            )}

            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                {conferenceTitle || "Selected Conference"}
              </Typography>
              {conferenceDate && (
                <Typography variant="body2" sx={{ color: "#555" }}>
                  📅 {new Date(conferenceDate).toLocaleDateString()}
                </Typography>
              )}
              {priceType && (
                <Typography variant="body1" sx={{ fontWeight: 600, color: "#9B1321", mt: 0.5 }}>
                  💰 {priceType} - ${priceAmount}
                </Typography>
              )}
              {priceDescription && (
                <Typography variant="body2" sx={{ color: "#777", mt: 0.5 }}>
                  {priceDescription}
                </Typography>
              )}
              <br />
              {/* ✅ PERFECT: Dynamic What's Include with same styling */}
              <p><b>Your registration includes the following:</b></p>
              {parsedWhatsInclude.length > 0 ? (
                <ul style={{ margin: "8px 0", paddingLeft: "20px" }}>
                  {parsedWhatsInclude.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              ) : (
                <ul style={{ margin: "8px 0", paddingLeft: "20px" }}>
                  <li>Conference Bag & Badge</li>
                  <li>Full Program Access</li>
                  <li>Exhibition Entry</li>
                  <li>CPD Certificate</li>
                </ul>
              )}
            </Box>
          </Box>
        )}

        {!state && (
          <Typography variant="body2" sx={{ color: "red", mb: 2, textAlign: "center" }}>
            ❌ Conference details not found.
          </Typography>
        )}

        {/* ✅ COMPLETE FORM - No changes */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              fullWidth
            >
              <MenuItem value="Mr.">Mr.</MenuItem>
              <MenuItem value="Mrs.">Mrs.</MenuItem>
              <MenuItem value="Ms.">Ms.</MenuItem>
              <MenuItem value="Dr.">Dr.</MenuItem>
              <MenuItem value="Prof.">Prof.</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Phone Number *
            </Typography>
            <PhoneInput
              country="jo"
              value={phone}
              onChange={(val) => setPhone(val)}
              inputStyle={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              WhatsApp Number
            </Typography>
            <PhoneInput
              country="jo"
              value={whatsApp}
              onChange={(val) => setWhatsApp(val)}
              inputStyle={{ width: "100%" }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Speciality"
              value={speciality}
              onChange={(e) => setSpeciality(e.target.value)}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Nationality"
              value={selectedNationalityId}
              onChange={(e) => {
                const val = e.target.value;
                setSelectedNationalityId(val);
                const selected = countries.find((c) => String(c.id) === String(val));
                setSelectedNationality(selected?.name || "");
              }}
              fullWidth
              required
            >
              <MenuItem value=""><em>Select nationality</em></MenuItem>
              {countries.map((c) => (
                <MenuItem key={c.id} value={String(c.id)}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <img
                      src={c.flag_url}
                      alt={c.name}
                      style={{
                        width: 22,
                        height: 16,
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />
                    <span>{c.name}</span>
                  </Box>
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Country of Residence"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              select
              label="How did you hear about the Event?"
              value={heardFrom}
              onChange={(e) => setHeardFrom(e.target.value)}
              fullWidth
            >
              <MenuItem value="Social media">Social media</MenuItem>
              <MenuItem value="Email newsletter">Email newsletter</MenuItem>
              <MenuItem value="Official website">Official website</MenuItem>
              <MenuItem value="Friend or colleague">Friend or colleague</MenuItem>
              <MenuItem value="Paid advertisement">Paid advertisement</MenuItem>
              <MenuItem value="Newspapers or magazines">Newspapers or magazines</MenuItem>
              <MenuItem value="Previous conference or event">Previous conference or event</MenuItem>
              <MenuItem value="Online search">Online search</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sx={{ mt: 1 }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
              <input
                type="checkbox"
                name="accept_cancellation_policy"
                checked={formData.accept_cancellation_policy}
                onChange={(e) =>
                  setFormData((p) => ({
                    ...p,
                    accept_cancellation_policy: e.target.checked,
                  }))
                }
                required
                style={{ marginTop: 3 }}
              />
              <span style={{ fontSize: 14, lineHeight: 1.4 }}>
                I agree to the{" "}
                <a
                  href="/cancellation-and-refund-policy"
                  style={{ fontWeight: "700", textDecoration: "underline", color: "#9B1321" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cancellation and Refund Policy
                </a>
                . I confirm that I have read and accepted the terms.
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: "#9B1321",
                  "&:hover": { backgroundColor: "#7E0F1B" },
                  paddingX: 8,
                  paddingY: 1.8,
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: "0 4px 12px rgba(155,19,33,0.3)",
                  minWidth: "250px",
                }}
                onClick={handleRegister}
                disabled={loading}
              >
                {loading ? (
                  <span>🔄 Processing Registration...</span>
                ) : (
                  `Register & Pay $${priceAmount || 150}`
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default RegisterAttendancePage;